export const SUBTITLE_MANAGED_CORE_STATE_EXTENSION_ID = '@recative/managed-core-state-extension-subtitle';
export const BGM_CORE_STATE_EXTENSION_ID = '@recative/managed-core-state-extension-bgm';
